import { Ifilter } from "./filter";

export interface IPlantillaVerificacionPOST {
  nombre?: string;
  equipoModeloId?: string;
  detallePlantilla?: IDetallePlantillaPOST[];
}

export const InitialPlantillaVerificacionPOST: IPlantillaVerificacionPOST = {
  nombre: "",
  equipoModeloId: "",
  detallePlantilla: [],
};

export interface IBodyUpdatePlantilla {
  nombre?: string;
  plantillaVerificacionId?: string;
  detallePropiedadId?: IDetallePropiedad[];
}
export interface IDetallePropiedad {
  detallePropiedadId: string;
  ordenGrupo: number;
}

export interface IDetallePlantillaPOST {
  propiedadVerificacionId?: string;
  orden?: number;
  ordenGrupo?: number;
}

export interface IPlantillaVerificacion {
  plantillaListaVerificacionId: string;
  nombre: string;
  activo: boolean;
  equipoModeloId: string;
  equipoModelo: string;
  fechaCreacion: string;
}
export interface IPlantillaVerificacionPersonaRequest extends Ifilter{
  personaId:string
}

export interface IPropiedadVerificacion {
  grupoVerificacionId: string;
  propiedadVerificacionId: string;
  nombre: string;
}

export interface IGrupoPropiedades {
  grupoVerificacionId: string;
  propiedadVerificacionId: string;
  nombre: string;
  orden: number;
  ordenGrupo: number;
}
export interface IDeletePlatillaPropiedadDetalle {
  PantillaVerificacionId: string;
  PropiedadVerificaccionId: string;
}

export interface IPostCrearPlantillaVerificacion {
  nombrePlantilla: string;
  equipoModeloId: string;
  detalle: IObjetoDetalle[];
}

export interface IObjetoDetalle {
  grupo: number;
  propiedadVerificacionId: string[];
}

export const InitialIPostCrearPlantillaVerificacion: IPostCrearPlantillaVerificacion =
  {
    nombrePlantilla: "",
    equipoModeloId: "",
    detalle: [],
  };
